import { InputRule } from 'prosemirror-inputrules';
import { getMarksBetween } from './mark.js';
import { createParagraphInheritAttrsTr } from '../commands/createParagraphInheritAttrs.js';
export function markInputRule(rule, markType) {
    return new InputRule(rule.match, (state, match, start, end) => {
        const attributes = rule.getAttrs instanceof Function ? rule.getAttrs(match) : rule.getAttrs;
        const { tr } = state;
        const captureGroup = match[match.length - 1];
        const fullMatch = match[0];
        let markEnd = end;
        if (captureGroup) {
            const startSpaces = fullMatch.search(/\S/);
            const textStart = start + fullMatch.indexOf(captureGroup);
            const textEnd = textStart + captureGroup.length;
            const excludedMarks = getMarksBetween(start, end, tr.doc)
                .filter((item) => {
                // @ts-ignore TODO: PR to add excluded to MarkType
                const { excluded } = item.mark.type;
                return excluded.find((type) => type.name === markType.name);
            })
                .filter((item) => item.to > textStart);
            if (excludedMarks.length) {
                return null;
            }
            if (textEnd < end) {
                tr.delete(textEnd, end);
            }
            if (textStart > start) {
                tr.delete(start + startSpaces, textStart);
            }
            markEnd = start + startSpaces + captureGroup.length;
            tr.addMark(start + startSpaces, markEnd, markType.create(attributes));
            tr.removeStoredMark(markType);
        }
        return tr;
    });
}
/**
 * 创建一个响应 Enter 的 ShortCut，补充 prosemirror-inputrules 对输入的处理。
 * 亦见 ExInputRule.captureEnter
 */
export function createEnterHandlerByInputRule(rule) {
    const ruleFull = rule;
    return function inputRuleEnterHandler(state, dispatch) {
        const { $from, from, empty } = state.selection;
        // 最大回溯 20 个字符。prosemirror-inputrules 内部使用的 500，对我们没必要
        const MAX_MATCH = 20;
        if (!empty) {
            return false;
        }
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset, null, '\ufffc');
        const matched = `${textBefore}\n`.match(ruleFull.match);
        if (!matched) {
            return false;
        }
        // trBase 和 stateBase 是不使用 inputRule 时，自然的结果。
        // 这个结果 undo inputRule 时要用
        const trBase = createParagraphInheritAttrsTr(state);
        if (trBase) {
            dispatch === null || dispatch === void 0 ? void 0 : dispatch(trBase);
        }
        const stateBase = trBase ? state.apply(trBase) : state;
        // +1 为减掉虚拟的 \n
        const start = from - matched[0].length + 1;
        const tr = ruleFull.handler(stateBase, matched, start, stateBase.selection.to);
        if (tr) {
            // 尽量准备 undoInputRule 所需的 meta 信息
            const inputRulesPlugin = state.plugins.find((p) => p.spec.isInputRules);
            if (inputRulesPlugin) {
                tr.setMeta(inputRulesPlugin, { transform: tr });
            }
            dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
            return true;
        }
    };
}
//# sourceMappingURL=input-rule.js.map